export default __webpack_public_path__ + "static/media/about-sec-img.b73d819a.png";